export default __webpack_public_path__ + "static/media/team-5.3f5d0982.jpg";